// In-flight request de-duplication (speed audit, 2026-10-19).
//
// Several components on one page ask the same question at the same moment
// (client users twice on Client Overview, data-config clients three times,
// the Assistant access check from three places). The second asker gets the
// first asker's promise instead of a second round trip; the answer is held
// for a short window so a mount a few hundred ms later reuses it too.
// Failures are not held: the next caller asks again.
const inflight = new Map(); // key -> { promise, at }

export function dedupe(key, fn, ttlMs = 2000) {
    const now = Date.now();
    const hit = inflight.get(key);
    if (hit && now - hit.at < ttlMs) return hit.promise;
    const promise = Promise.resolve().then(fn);
    inflight.set(key, { promise, at: now });
    promise.catch(() => { if (inflight.get(key)?.promise === promise) inflight.delete(key); });
    return promise;
}

/** Forget one key (after a write that changes the answer) or everything. */
export function forget(prefix = '') {
    [...inflight.keys()].filter((k) => k.startsWith(prefix)).forEach((k) => inflight.delete(k));
}
